import { getServiceCatalog, postBackbone, getBackbone } from '@/library/http';

export const getRegistration = async (id: string, envs: boolean, details: boolean) =>
  getServiceCatalog(`/registration/${id}?environments=${envs}&details=${details}`);

export const getExternalDnsRecords = async (
  id: string,
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  domain: string,
  type: string,
  name: string,
  value: string,
  status: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  sortBy?.length ? (filter += `&orderBy=${sortBy}`) : false;
  domain?.length ? (filter += `&domain=${domain}`) : false;
  type?.length ? (filter += `&type=${type}`) : false;
  name?.length ? (filter += `&name=${name}`) : false;
  value?.length ? (filter += `&value=${value}`) : false;
  status?.length && status !== 'removed' ? (filter += `&status=${status}`) : false;
  status?.length && status === 'removed' ? (filter += `&deleted=true`) : false;

  return getServiceCatalog(`/registration/${id}/external-dns?limit=${limit}&skip=${skip}${filter}`);
};

export const getInternalDnsRecords = async (
  id: string,
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  domain: string,
  type: string,
  name: string,
  value: string,
  status: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  sortBy?.length ? (filter += `&orderBy=${sortBy}`) : false;
  domain?.length ? (filter += `&domain=${domain}`) : false;
  type?.length ? (filter += `&type=${type}`) : false;
  name?.length ? (filter += `&name=${name}`) : false;
  value?.length ? (filter += `&value=${value}`) : false;
  status?.length && status !== 'removed' ? (filter += `&status=${status}`) : false;
  status?.length && status === 'removed' ? (filter += `&deleted=true`) : false;

  return getServiceCatalog(`/registration/${id}/internal-dns?limit=${limit}&skip=${skip}${filter}`);
};

export const getZones = async (
  id: string,
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  name: string,
  license: string,
  dns: string,
  status: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  sortBy?.length ? (filter += `&orderBy=${sortBy}`) : false;
  name?.length ? (filter += `&zoneName=${name}`) : false;
  license?.length ? (filter += `&license=${license}`) : false;
  dns?.length ? (filter += `&dns=${dns === 'enabled' ? 'true' : 'false'}`) : false;
  status?.length && status !== 'removed' ? (filter += `&status=${status}`) : false;
  status?.length && status === 'removed' ? (filter += `&deleted=true`) : false;

  return getServiceCatalog(`/registration/${id}/zones?limit=${limit}&skip=${skip}${filter}`);
};

export const getFirewallRules = async (
  limit: number,
  skip: number,
  sortBy: string,
  srcApmId: string,
  dstApmId: string,
  descending: boolean,
  port: string,
  protocol: string,
  srcIp: string,
  dstIp: string,
  status: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  sortBy?.length ? (filter += `&orderBy=${sortBy}`) : false;
  port?.length ? (filter += `&port=${port}`) : false;
  protocol?.length ? (filter += `&protocol=${protocol}`) : false;
  srcIp?.length ? (filter += `&srcIp=${srcIp}`) : false;
  dstIp?.length ? (filter += `&dstIp=${dstIp}`) : false;
  srcApmId?.length ? (filter += `&srcApmId=${srcApmId}`) : false;
  dstApmId?.length ? (filter += `&dstApmId=${dstApmId}`) : false;
  status?.length && status !== 'removed' ? (filter += `&status=${status}`) : false;
  status?.length && status === 'removed' ? (filter += `&deleted=true`) : false;

  return getServiceCatalog(`/registration/firewall-rules?limit=${limit}&skip=${skip}${filter}`);
};

export const getCertifiedProductsArtifacts = async (id: string) => {
  return getServiceCatalog(`/registration/${id}/certified-products/artifacts`);
  //return ['Art1', 'Art2'];
};

export const getCertifiedProducts = async (
  id: string,
  artifactName: string,
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  resourceName: string,
  resourceGroup: string,
  environment: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  sortBy?.length ? (filter += `&orderBy=${sortBy}`) : false;
  resourceName?.length ? (filter += `&resourceName=${resourceName}`) : false;
  resourceGroup?.length ? (filter += `&resourceGroup=${resourceGroup}`) : false;
  environment ? (filter += `&environment=${environment}`) : false;
  return getServiceCatalog(
    `/registration/${id}/certified-products/${artifactName}?limit=${limit}&skip=${skip}${filter}`,
  );
};

export const getAlibabaEnvs = async (
  id: string,
  limit: number,
  skip: number,
  sortBy: string,
  descending: boolean,
  environment: string,
  region: string,
  subnets: string,
  vpcId: string,
  status: string,
) => {
  let filter = '';
  filter += `&order=${descending ? 'DESC' : 'ASC'}`;
  sortBy?.length ? (filter += `&orderBy=${sortBy}`) : false;
  environment?.length ? (filter += `&environment=${environment}`) : false;
  region ? (filter += `&region=${region}`) : false;
  subnets?.length ? (filter += `&subnets=${subnets}`) : false;
  vpcId?.length ? (filter += `&vpcId=${vpcId}`) : false;
  status?.length && status !== 'removed' ? (filter += `&status=${status}`) : false;
  status?.length && status === 'removed' ? (filter += `&deleted=true`) : false;

  return getServiceCatalog(`/registration/${id}/alibaba?limit=${limit}&skip=${skip}&${filter}`);
};

export const subValWorkflow = (data: any) => postBackbone(`/engine/subval/create-workflow`, data);

export const createWorkFlow = (data: any) => postBackbone(`/engine/create-workflow`, data);

export const authWorkflow = (data: any) => postBackbone('/engine/preauth/create-workflow', data);

export const validateWorkFlow = (data: any) => postBackbone(`/engine/preval/create-workflow`, data);

export const extractPrevalMessages = (response: any) => {
  return (response?.errors || []).filter((message: any) => ['info', 'warning'].includes(message?.severity));
};

export const getBluePrint = (id: string) => getBackbone(`/blueprints/${id}`);

export const resourceMakeApiCall = (data: any) => postBackbone(`/api-calls/get-resource`, data);

export const getRelatedWorkflowsStatuses = (id: string) => getBackbone(`/workflows/distinct-statuses/${id}`);

export const getRoles = (role: string) =>
  getBackbone(`/access-products/groups?fields=displayName&filter=securityEnabled eq true&name=${role}`);

export const checkIp = (ip: string, type: string) =>
  getServiceCatalog(`/connectivity-matrix/network-record-apm?ip=${ip}&ipType=${type}`);

export const getSegments = (apmId: string | null) => {
  const filter = apmId ? `?apmId=${apmId}` : '';
  return getServiceCatalog(`/connectivity-matrix/segments${filter}`);
};

export const getSegmentsAutocomplete = () => {
  return getServiceCatalog('/connectivity-matrix/segments/autocomplete');
};

export const getAlibabaAccounts = (apmid: string) => getBackbone(`/snow/alibaba-accounts?apmid=${apmid}`);

export const getSummary = (data: any) => {
  return postBackbone('/role-composition-v2/summary', data);
};
